import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const categoryIcons = {
  Cybersecurity: (
    <svg viewBox="0 0 24 24" className="w-3.5 h-3.5 fill-cyber-blue" stroke="none">
      <path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm0 10.99h7c-.53 4.12-3.28 7.79-7 8.94V12H5V6.3l7-3.11v8.8z" />
    </svg>
  ),
  "CCTV Deployment": (
    <svg viewBox="0 0 24 24" className="w-3.5 h-3.5 fill-cyber-blue" stroke="none">
      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm0 14.2c-2.5 0-4.71-1.28-6-3.22.03-1.99 4-3.08 6-3.08 1.99 0 5.97 1.09 6 3.08-1.29 1.94-3.5 3.22-6 3.22z" />
    </svg>
  ),
  "Network Infrastructure": (
    <svg viewBox="0 0 24 24" className="w-3.5 h-3.5 fill-cyber-blue" stroke="none">
      <path d="M20 2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM8 20H4v-4h4v4zm0-6H4v-4h4v4zm0-6H4V4h4v4zm6 12h-4v-4h4v4zm0-6h-4v-4h4v4zm0-6h-4V4h4v4zm6 12h-4v-4h4v4zm0-6h-4v-4h4v4zm0-6h-4V4h4v4z" />
    </svg>
  ),
  "Web Systems": (
    <svg viewBox="0 0 24 24" className="w-3.5 h-3.5 fill-cyber-blue" stroke="none">
      <path d="M9.4 16.6L4.8 12l4.6-4.6L8 6l-6 6 6 6 1.4-1.4zm5.2 0l4.6-4.6-4.6-4.6L16 6l6 6-6 6-1.4-1.4z" />
    </svg>
  ),
  "Digital Forensics": (
    <svg viewBox="0 0 24 24" className="w-3.5 h-3.5 fill-cyber-blue" stroke="none">
      <path d="M15.5 14h-.79l-.28-.27A6.47 6.47 0 0016 9.5 6.5 6.5 0 109.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z" />
    </svg>
  ),
  "Threat Hunting": (
    <svg viewBox="0 0 24 24" className="w-3.5 h-3.5 fill-cyber-blue" stroke="none">
      <path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm0 10.99h7c-.53 4.12-3.28 7.79-7 8.94V12H5V6.3l7-3.11v8.8z" />
      <circle cx="12" cy="12" r="3" fill="none" stroke="currentColor" strokeWidth="2" className="text-cyber-blue" />
    </svg>
  ),
  "Network Analysis": (
    <svg viewBox="0 0 24 24" className="w-3.5 h-3.5 fill-cyber-blue" stroke="none">
      <path d="M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z" />
    </svg>
  ),
  "Vulnerability Management": (
    <svg viewBox="0 0 24 24" className="w-3.5 h-3.5 fill-cyber-blue" stroke="none">
      <path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm0 10.99h7c-.53 4.12-3.28 7.79-7 8.94V12H5V6.3l7-3.11v8.8z" />
      <path d="M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z" />
    </svg>
  ),
  OSINT: (
    <svg viewBox="0 0 24 24" className="w-3.5 h-3.5 fill-cyber-blue" stroke="none">
      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z" />
    </svg>
  ),
  "ISP & Network Solutions": (
    <svg viewBox="0 0 24 24" className="w-3.5 h-3.5 fill-cyber-blue" stroke="none">
      <path d="M12 12c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-2.76 0-5 2.24-5 5h2c0-1.66 1.34-3 3-3s3 1.34 3 3h2c0-2.76-2.24-5-5-5zm0-4c-4.96 0-9 4.04-9 9h2c0-3.86 3.14-7 7-7s7 3.14 7 7h2c0-4.96-4.04-9-9-9z" />
    </svg>
  ),
};

export default function CaseCard({ slug, title, category, shortDesc, image, index, techniques, outcomeSummary }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.6, delay: index * 0.1 }}
    >
      <Link
        to={`/cases/${slug}`}
        className="group block glass rounded-2xl overflow-hidden glass-hover glow-cyber"
      >
        <div className="relative overflow-hidden">
          <img
            src={image}
            alt={title}
            className="w-full h-48 sm:h-64 object-cover transition-transform duration-500 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-[#0a0a0a] via-transparent to-transparent" />
          <span className="absolute top-4 left-4 glass text-xs font-semibold px-3 py-1 rounded-full text-cyber-blue inline-flex items-center gap-1.5">
            {categoryIcons[category] || null}
            {category}
          </span>
        </div>
        <div className="p-6">
          <h3 className="text-xl font-bold text-white group-hover:text-cyber-blue transition-colors">
            {title}
          </h3>
          <p className="text-gray-400 text-sm mt-2 leading-relaxed">
            {shortDesc}
          </p>
          {techniques && (
            <div className="flex flex-wrap gap-1.5 mt-3">
              {techniques.map((t) => (
                <span
                  key={t}
                  className="text-[10px] glass px-2 py-0.5 rounded-full text-gray-400"
                >
                  {t}
                </span>
              ))}
            </div>
          )}
          {outcomeSummary && (
            <p className="text-tech-green/80 text-xs mt-3 leading-relaxed border-t border-white/5 pt-3">
              {outcomeSummary}
            </p>
          )}
          <span className="inline-block mt-4 text-tech-green text-sm font-semibold group-hover:translate-x-2 transition-transform">
            Read Case Study →
          </span>
        </div>
      </Link>
    </motion.div>
  );
}
